import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spin, message } from 'antd';
import { getNamesByLanguage } from '../../constants';
import FooterButton from '../Components/FooterButton';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import actions from '../../store/actions';
import Form from './Form';

let names = {};

class Cover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            loading: false,
            editable: false,
        };
    }

    componentDidMount() {
        const { status, language } = this.props;
        let editable = false;
        if (status === 'add') {
            editable = true;
        }
        this.setState({ editable }, () => {
            this.loadData();
        });
        names = getNamesByLanguage('cover', language);
    }

    loadData = () => {
        const { quotationInfo } = this.props;
        const { userId, userName } = sessionStorage;
        this.setState({
            data: {
                serverType: 'CRC服务',
                submitCompany: '上海津石医药科技有限公司',
                submitCompanyAddress: '上海市黄浦区马当路388号SOHO复兴广场A座803室',
                submitCompayTele: '86(21)5306 1011',
                baName: userName,
                baId: userId,
                approver: '洪有源',
                ...quotationInfo,
            },
            prevData: {
                serverType: 'PM服务',
            }
        });
    }

    handleChange = (data) => {
        this.props.hasChange();
        this.setState({ data });
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            // if (!this.formRef.validate()) return;
            const { status } = this.props;
            const { data } = this.state;
            this.props.saveQuotationInfo({
                ...data,
                quotationId: 1,
                quotationNum: '202009151652',
                version: 'V1'
            });
            status === 'add' && this.props.changeStep(1);
        }
    }

    toggleEditable = (editable) => {
        this.setState({ editable }, () => {
            !editable && this.loadData();
        });
    }

    render() {
        const { status, height, language } = this.props;
        const { loading, editable, data, prevData } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="quotation-content paddingBottom10" style={{ height }}>
                    <h2 className="quotation-title">{names.title}</h2>
                    <Form
                        data={data}
                        names={names}
                        prevData={prevData}
                        // mode="compare"
                        editable={editable}
                        language={language}
                        onChange={this.handleChange}
                        formRef={el => this.formRef = el}
                    />
                </div>
                <FooterButton
                    status={status}
                    editable={editable}
                    confirm={this.confirm}
                    toggleEditable={this.toggleEditable}
                />
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.quotationState,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Cover);


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Cover/index.js